import { Component, OnInit } from '@angular/core';
import { FormGroup,FormControl,Validators } from '@angular/forms';
import {HttpserviceService} from '../common/services/httpservice.service';
import {retry} from 'rxjs/operators';
import { SessionsService } from '../common/services/sessions.service';
import {ConstantsService} from '../common/services/constants.service';
import {UtilsService} from '../common/services/utils.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-my-account-left-menu',
  templateUrl: './my-account-left-menu.component.html',
  styleUrls: ['./my-account-left-menu.component.css']
})
export class MyAccountLeftMenuComponent implements OnInit {

  editProfilePicStatus:boolean=false;
   selectedProfilePic;
   isProfilePicConfirm:boolean=false;
   isRequestInprocess:boolean=false;
   profilePicUpdateStatus:string="";
   profilePicUrl:string="assets/images/users/male/25.jpg";
   page:string=""; 
   userName:string="";
   sessionProfileType:number=-1;

  constructor(
    private httpserviceService:HttpserviceService,
    private sessionsService:SessionsService,
    private _constant: ConstantsService,
    private utilsService:UtilsService,
    private router:Router
    ) { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    if(this.sessionsService.getSession("profile_type")!=null)
    {
       this.sessionProfileType=this.sessionsService.getSession("profile_type");
    }
    if(this.sessionsService.getSession("profile_pic"))
    {
    this.profilePicUrl= this.sessionsService.getSession("profile_pic");
    }
    this.userName=this.sessionsService.getSession("first_name")+" "+this.sessionsService.getSession("last_name");
        
    this.page = this.router.url.split("/").pop();        
  }

  /** editProfilePic function used to open edit profile pic  */
  editProfilePic()
  {
    this.editProfilePicStatus=true;
  }

  /** cancelEditProfilePic function used to cancel edit profile pic  */ 
  cancelEditProfilePic()
  {
    this.editProfilePicStatus=false;
    this.isProfilePicConfirm=false;
    this.profilePicUpdateStatus="";
  }

  /** selectProfilePic function used to select profile pic */
  selectProfilePic(event) {    
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.selectedProfilePic= file;
      //});
    }
    else{
       this.selectedProfilePic="";
    }
  }

  /** proceedProfilePicConfirmRequest function used to proceed profile pic confirm request */
  proceedProfilePicConfirmRequest()
  {
    this.isProfilePicConfirm=true;
    if(this.selectedProfilePic && this.selectedProfilePic!="")
    {
      this.isRequestInprocess=true;
      this.profilePicUpdateStatus="Profile pic updating...";
      let formData=new FormData();
      formData.append("profile_pic",this.selectedProfilePic);
      formData.append('profile_id',this.sessionsService.getSession("id"));
      let result =this.httpserviceService.updateProfilePicRequest(formData).
     pipe(retry(0)).
     subscribe((data)=>this.updateProfilePicResponse(data),
     err => {
       this.isRequestInprocess=false; 
       this.profilePicUpdateStatus="Something went wrong !";
       console.log('Something went wrong ', err);       
    })
    }
    else
    {
      this.profilePicUpdateStatus="Select profile image";
    }
  }

 /** updateProfilePicResponse function used to handle response */
  updateProfilePicResponse(response)
  {
    console.log('registrationResponse '+ response.status);
    if(response.status==="success")  
     {      
    this.isRequestInprocess=false;
    this.profilePicUpdateStatus="Profile pic updated successfully";

    if(response.details)
    {
      let array=response.details;
      for(let i=0;i<array.length;i++)
      {
      this.sessionsService.setSession("profile_pic",array[i].profile_pic);   
      if(this.sessionsService.getSession("profile_pic"))
        {
        this.profilePicUrl= this.sessionsService.getSession("profile_pic");
        }
      }  
    }
    
    setTimeout(() => {
      this.cancelEditProfilePic();
    }, 2000);
     }
     else
     {
     this.profilePicUpdateStatus=response.reason;
     this.isRequestInprocess=false;    
     } 
  }

  myCars()
  {
    this.router.navigate(['my-cars']);
  }

  myProfile()
  {
     this.router.navigate(['my-profile']);
  }

  myPreference()
  {
     this.router.navigate(['my-preference']);
  }

   myPaymentHistory()
  {
     this.router.navigate(['my-payment-history']);
  }  

  /** howItsWork function used to open how its work page */
  myInspection()
  {
     this.router.navigate(['my-inspection']);
  }

  /** logout function used to remove all sessions  */
  logout()
  {
        this.sessionsService.removeSession("login_status");
        this.sessionsService.removeSession("id");
        this.sessionsService.removeSession("first_name");
        this.sessionsService.removeSession("last_name");
        this.sessionsService.removeSession("profile_pic"); 
        this.sessionsService.removeSession("email_id");
        this.sessionsService.removeSession("mobile_no");
        this.sessionsService.removeSession("dealership_name");
        this.sessionsService.removeSession("profile_type");
        this.sessionsService.removeSession("status");
        this.sessionsService.removeSession("city_id");
        this.sessionsService.removeSession("state_id");
         window.location.href="#/visitor";
  }

//   $scope.getClass = function (path) {
//   return ($location.path().substr(0, path.length) === path) ? 'active' : '';
// }

}
